import React from 'react'
import { camelCase, kebabCase } from 'lodash'

import {
  IProps as ILargeTestimonialMvp,
  LargeTestimonial as LargeTestimonialMVP,
} from 'marketing-site/src/mvp/library/components/LargeTestimonial'
import {
  CONTENT_TYPE,
  ILargeTestimonialMvp as IContentfulLargeTestimonialMvp,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { Image } from 'marketing-site/src/library/elements/Image'

export const ContentfulLargeTestimonial = (
  LargeTestimonial: IContentfulLargeTestimonialMvp,
): React.ReactElement => {
  return (
    <EntryMarker entry={LargeTestimonial}>
      {() => <LargeTestimonialMVP {...transformLargeTestimonial(LargeTestimonial)} />}
    </EntryMarker>
  )
}

const transformCTA = (cta: IContentfulLargeTestimonialMvp['fields']['cta']) => {
  if (!cta) return
  const contentTypeId = cta?.sys.contentType?.sys.id as CONTENT_TYPE
  return renderTransformedComponent(contentTypeId, cta)
}

const transformMedia = (
  media:
    | IContentfulLargeTestimonialMvp['fields']['image']
    | IContentfulLargeTestimonialMvp['fields']['companyLogo'],
) => {
  if (!media) return
  return <Image url={media.fields.file.url} />
}

export function transformLargeTestimonial({
  fields,
}: IContentfulLargeTestimonialMvp): ILargeTestimonialMvp {
  return {
    ...fields,
    layout: fields.layout && (kebabCase(fields.layout) as ILargeTestimonialMvp['layout']),
    image: fields.image && transformMedia(fields.image),
    quote: documentToHtmlString(fields.quote),
    companyLogo: fields.companyLogo && transformMedia(fields.companyLogo),
    cta: fields.cta && transformCTA(fields.cta),
    backgroundColor:
      fields.backgroundColor &&
      (camelCase(fields.backgroundColor) as ILargeTestimonialMvp['backgroundColor']),
  }
}
